import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import * as comunCss from "../../components/comum_css";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { v } from "../../util";
import { LetterCircle } from "../../components/gestaoBot/components/LetterCircle";
import InputPhone from "../../components/input-fone";
import { IUserInfo } from "../../services/omnichannelService";
import { iDialogMessagesFile } from "../use-omnichannel";
import inputFone from "../../components/input-fone";
import { Check } from "../../assets";
import {
  CheckButton,
  Divisor,
  MyImage
} from "../../components/gestaoBot/components/CreateCampaign/styles";

export interface ChatInfosBodyProps {
  dialog: iDialogMessagesFile;
  contactInfo: IUserInfo | null;
  onSaveContact: (data: {
    name: string;
    phone: string;
    email: string | null;
  }) => void;
}
const ChatInfosBody = (ChatInfosBodyProps: ChatInfosBodyProps) => {
  interface ChatInfoValidation {
    name: string;
    email: string;
    phone: string;
    description: string;
  }

  const [maskedPhone, setMaskedPhone] = useState(["", ""]);
  const [nameField, setNameField] = useState("");
  const [emailField, setEmailField] = useState("");
  const [phoneField, setPhoneField] = useState("");
  const [descriptionField, setDescriptionField] = useState("");

  const onChangeName = (name: string) => setNameField(name);
  const onChangeEmail = (email: string) => setEmailField(email);
  const onChangeDescription = (description: string) =>
    setDescriptionField(description);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<ChatInfoValidation>({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      description: ""
    },
    values: {
      name: nameField,
      email: emailField,
      phone: phoneField,
      description: descriptionField
    },
    resolver: zodResolver(
      v.object({
        name: v.string().superRefine(v.nonempty()),
        email: v.string(),
        phone: v.string(),
        description: v.string()
      })
    )
  });

  useEffect(() => {
    if (!ChatInfosBodyProps.contactInfo) {
      return;
    }

    setValue("name", ChatInfosBodyProps.contactInfo.name || "");
    setValue("email", ChatInfosBodyProps.contactInfo.email || "");
    setValue("phone", ChatInfosBodyProps.contactInfo.phone || "");
    setNameField(ChatInfosBodyProps.contactInfo.name || "");
    setEmailField(ChatInfosBodyProps.contactInfo.email || "");
    setPhoneField(ChatInfosBodyProps.contactInfo.phone || "");
  }, [ChatInfosBodyProps.contactInfo, setValue]);

  const handleInputChange = (values: string[]) => {
    const completePhone = values[0] + values[1];

    setMaskedPhone(values);

    setPhoneField(completePhone);
  };

  const handleSave = () => {
    ChatInfosBodyProps.onSaveContact({
      name: nameField.trim(),
      phone: phoneField.trim(),
      email: emailField.trim() === "" ? null : emailField.trim()
    });
  };

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          padding: 10px 1rem 60px 1rem;
          overflow: auto;
          flex: 1;
          min-height: 0;
        `}
      >
        <b
          css={css`
            font-size: 16px;
            margin: 20px 0 5px 10px;
          `}
        >
          Informações
        </b>

        <div
          css={css`
            display: flex;
            align-items: center;
            height: 48px;
            width: 100%;
            padding: 0.8rem;
            margin: 10px 0;
            border-radius: 2px;
            border: 1px solid #d2d2d2;
            background: #ffffff;
            color: #4c5862;

            @media screen and (max-width: 400px) {
              font-size: 12px;
            }
          `}
        >
          Criado por:
          <LetterCircle initial={nameField} />
          {nameField}
        </div>

        <span className="field mb-1 relative" style={{ top: "-10px" }}>
          <label
            css={comunCss.inputLabelDefault}
            htmlFor="userName"
            className="block"
          >
            Nome do usuário
          </label>

          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <InputText
                {...field}
                className="w-full"
                css={comunCss.noBorder}
                id="userName"
                value={nameField}
                onChange={(e) => {
                  onChangeName(e.target.value);
                  field.onChange(e.target.value);
                }}
              />
            )}
          />

          {errors.name?.message ? (
            <div style={{ color: "#AA3939" }}>{errors.name.message}</div>
          ) : null}
        </span>
        <span className="field mb-1 relative" style={{ top: "-10px" }}>
          <label
            css={comunCss.inputLabelDefault}
            htmlFor="phone"
            className="block"
          >
            Telefone
          </label>

          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <InputText
                {...field}
                className="w-full"
                css={comunCss.noBorder}
                id="userPhone"
                value={phoneField}
                onChange={(e) => {
                  setPhoneField(e.target.value);
                  field.onChange(e.target.value);
                }}
              />
            )}
          />

          {errors.name?.message ? (
            <div style={{ color: "#AA3939" }}>{errors.name.message}</div>
          ) : null}
        </span>

        {/* <InputPhone
          id="phone-input"
          value={inputFone}
          onChange={handleInputChange}
        /> */}

        <span className="field mb-0 relative" style={{ top: "-10px" }}>
          <label css={comunCss.inputLabelDefault} htmlFor="userEmail">
            E-mail
          </label>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <InputText
                {...field}
                className="w-full"
                css={comunCss.noBorder}
                id="userEmail"
                value={emailField}
                onChange={(e) => {
                  onChangeEmail(e.target.value);
                  field.onChange(e.target.value);
                }}
              />
            )}
          />
        </span>
        {errors.email?.message ? (
          <div style={{ color: "#AA3939" }}>{errors.email.message}</div>
        ) : null}
      </div>

      <div
        css={css`
          display: flex;
          flex-direction: column;
          position: sticky;
          bottom: 0;
          background: #ffffff;
          margin-top: auto;
          padding-bottom: 0.25rem;
          z-index: 2;
        `}
      >
        <Divisor />
        <div
          css={css`
            padding: 5px;
          `}
        >
          <button
            type="button"
            css={CheckButton}
            style={{ width: "100%", margin: 0 }}
            onClick={handleSubmit(() => handleSave())}
          >
            <MyImage src={Check} alt="Check-Button" />
            <div style={{ fontWeight: "bold" }}>Salvar</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInfosBody;
